import React from 'react'

const NonDestructiveTestingServices = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Non-Destructive Testing (NDT) Services </h3>
              <p className="mb-30">
                Non-Destructive Testing (NDT) is a critical quality assurance
                and safety measure used to assess the integrity, reliability,
                and performance of materials, structures, and components without
                causing any damage. NDT is essential for detecting flaws,
                defects, or discontinuities in metals, concrete, composites, and
                industrial equipment before they lead to failure.
              </p>
              <p className="mb-30">
                The requirement for NDT arose from the need to prevent
                catastrophic structural failures, ensure product quality, and
                follow regulatory and safety standards. Without NDT,
                organizations face undetected defects, operational risks,
                premature failures, and increased maintenance costs.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Purpose and Engineering Importance</h3>
                  <p className="mb-30">
                    The primary goal of NDT is to find defects, assess material
                    conditions, and verify structural integrity without
                    compromising functionality. Benefits include:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Early detection of cracks, corrosion, voids, and other
                      defects
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring compliance with design specifications, codes, and
                      regulations
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Supporting maintenance, repair, and life extension
                      decisions
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Reducing downtime and avoiding catastrophic failures
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Improving safety and reliability in industrial and
                      construction projects
                    </li>
                  </ul>
                  <p className="mb-30">
                    NDT provides confidence in material and structural
                    performance, while saving costs associated with destructive
                    testing or unexpected failures.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides comprehensive NDT services
                  across industries including construction, oil & gas,
                  petrochemical, power plants, infrastructure, and
                  manufacturing. Our certified technicians use advanced
                  equipment and internationally recognized procedures to ensure
                  correct and reliable results.
                </p>
                <p className="mb-30">
                  We offer on-site and laboratory NDT solutions, ensuring
                  minimal disruption to operations while keeping high safety and
                  quality standards.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope of NDT Services </h3>
                <h4 className="">Our NDT services typically include:</h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Visual and Surface Testing</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Visual Inspection (VT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dye Penetrant Testing
                        (PT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Magnetic Particle Testing
                        (MT).
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Volumetric and Internal Testing</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Ultrasonic Testing (UT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Radiographic Testing (RT
                        / X-Ray).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Phased Array Ultrasonic
                        Testing (PAUT).
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Specialized NDT Techniques</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Eddy Current Testing
                        (ET).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Acoustic Emission Testing
                        (AET).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Leak Testing (LT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Infrared Thermography.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Concrete and Civil Structure NDT</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Rebar Detection and
                        Mapping.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ultrasonic Pulse Velocity
                        (UPV).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Schmidt Hammer / Rebound
                        Hammer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ground Penetrating Radar
                        (GPR).
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NonDestructiveTestingServices